export interface BoxValueEntry<T> {
    aliases?: string[];
    key: string;
    value: T;
}

export class BoxValues<T> {
    private readonly entriesList: BoxValueEntry<T>[];

    public constructor(entries: BoxValueEntry<T>[]) {
        this.entriesList = entries;
    }

    public count(): number {
        return this.entriesList.length;
    }

    public entries(): BoxValueEntry<T>[] {
        return [...this.entriesList];
    }

    public get(indexOrKey: number | string): T | null {
        if (typeof indexOrKey === 'number') {
            return this.entriesList[indexOrKey]?.value ?? null;
        }

        return this.entriesList.find((entry) => {
            return entry.key === indexOrKey || entry.aliases?.includes(indexOrKey);
        })?.value ?? null;
    }

    public getFirst(): T | null {
        return this.get(0);
    }

    public getLast(): T | null {
        return this.entriesList[this.entriesList.length - 1]?.value ?? null;
    }

    public keys(): string[] {
        return this.entriesList.flatMap((entry) => {
            return [entry.key, ...(entry.aliases ?? [])];
        });
    }

    public values(): T[] {
        return this.entriesList.map((entry) => entry.value);
    }
}
